import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useContractDocument } from '../../../services/contractDocument';
import { InternalContractDocumentData } from '../../BaseController/types/internalContract';

export interface DownloadProps {
  downloadData: InternalContractDocumentData[];
  contractNumber: string;
  contractPosition: string;
}

export const Downloads = (props: DownloadProps) => {
  const { t } = useTranslation();
  const { downloadData, contractNumber, contractPosition } = props;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { res, callAPI } = useContractDocument();

  const openPDF = (base64Value: string) => {
    const pdfWindow = window.open('');
    pdfWindow?.document.write(
      `<iframe width='100%' height='100%' src='data:application/pdf;base64,${encodeURI(
        base64Value,
      )}'></iframe>`,
    );
    pdfWindow?.document.close();
  };

  return (
    <Stack direction="column" spacing={2} sx={{ width: '100%' }}>
      <Typography variant="headlineDetailSection">{t('Downloads')}</Typography>
      <Stack>
        {downloadData.length > 0 ? (
          downloadData.map((item) => (
            <Stack direction="row" spacing={0} key={item.archiveDocId}>
              <Button
                onClick={() => {
                  callAPI(item, contractNumber, contractPosition).then(
                    (result) => {
                      if (result?.data) {
                        openPDF(result.data);
                      }
                    },
                  );
                }}
                startIcon={<FileDownloadIcon />}
                sx={{
                  color: 'black',
                  textTransform: 'none',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                {`${item.documentDate} ${t(item.documentTypeName)} (PDF)`}
              </Button>
            </Stack>
          ))
        ) : (
          <Typography>{t('Downloads.NoneAvailable')}</Typography>
        )}
      </Stack>
    </Stack>
  );
};
